export default __webpack_public_path__ + "static/media/LBlock.79b37581.png";